(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Two copies only loop seamlessly when one copy already spans the screen.
    // With a single short message it doesn't, so the strip scrolls off and the
    // viewer waits for it to come back around. Clone the seed until one half
    // covers the viewport, then keep the track an exact pair of halves so the
    // -50% keyframe still lands on an identical frame.
    function layout(bar) {
      var track = bar.querySelector('[data-marquee-track]');
      if (!track) return;

      var seed = track.__marqueeSeed || track.querySelector('.announcement-bar__group');
      if (!seed) return;
      track.__marqueeSeed = seed;

      var groupWidth = seed.getBoundingClientRect().width;
      var barWidth = bar.getBoundingClientRect().width;
      // Fonts may not have loaded yet; a zero measurement would divide badly.
      if (!groupWidth || !barWidth) return;

      var perHalf = Math.max(1, Math.ceil(barWidth / groupWidth) + 1);
      var needed = perHalf * 2;
      if (track.__marqueeCount === needed) return;

      var fragment = document.createDocumentFragment();
      for (var i = 0; i < needed; i++) {
        var copy = seed.cloneNode(true);
        if (i > 0) {
          // Only the first copy is real content; the rest are visual filler and
          // must not be announced twice or land in the tab order.
          copy.setAttribute('aria-hidden', 'true');
          copy.querySelectorAll('a').forEach(function (link) {
            link.setAttribute('tabindex', '-1');
          });
        }
        fragment.appendChild(copy);
      }
      track.textContent = '';
      track.appendChild(fragment);
      track.__marqueeCount = needed;

      // Duration from distance and speed, so apparent pace stays constant
      // however many messages there are.
      var speed = parseFloat(bar.dataset.marqueeSpeed) || 70;
      track.style.setProperty('--announcement-duration', (groupWidth * perHalf) / speed + 's');
    }

    function init() {
      var bars = document.querySelectorAll('.announcement-bar--marquee');
      bars.forEach(function (bar) {
        layout(bar);

        var pending;
        window.addEventListener('resize', function () {
          window.clearTimeout(pending);
          pending = window.setTimeout(function () { layout(bar); }, 150);
        });

        // Re-measure once webfonts settle — text width changes under them.
        if (document.fonts && document.fonts.ready) {
          document.fonts.ready.then(function () { layout(bar); });
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  class CartDrawer extends HTMLElement {
    constructor() {
      super();
      this.panel = this.querySelector('[data-cart-panel]');
      this.closers = this.querySelectorAll('[data-cart-close]');
      this.bindEvents();
    }

    bindEvents() {
      // Open from header cart icon
      document.addEventListener('cart:open', () => this.open());
      document.addEventListener('maison:escape', () => this.close());
      this.closers.forEach((c) => c.addEventListener('click', () => this.close()));

      // Wire interactions on initial render
      this.wireLineControls();
      this.wireQuickAddForms();

      // Dev-only convenience: open the drawer if ?cart=open is in the URL
      if (new URLSearchParams(window.location.search).get('cart') === 'open') {
        requestAnimationFrame(() => this.open());
      }
    }

    open() {
      this.removeAttribute('hidden');
      // Force reflow so the transition runs
      void this.offsetWidth;
      this.setAttribute('aria-hidden', 'false');
      document.body.classList.add('drawer-open');
      this.lastFocused = document.activeElement;
      const firstFocusable = this.panel.querySelector('button, [href], input, [tabindex]:not([tabindex="-1"])');
      if (firstFocusable) firstFocusable.focus();
    }

    close() {
      this.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('drawer-open');
      window.setTimeout(() => {
        if (this.getAttribute('aria-hidden') === 'true') this.setAttribute('hidden', '');
      }, 400);
      if (this.lastFocused) this.lastFocused.focus();
    }

    wireLineControls() {
      this.querySelectorAll('[data-cart-line]').forEach((line) => {
        const key = line.dataset.lineKey;
        const input = line.querySelector('[data-line-qty]');
        const decrease = line.querySelector('[data-line-decrease]');
        const increase = line.querySelector('[data-line-increase]');
        const remove = line.querySelector('[data-line-remove]');

        if (decrease) decrease.addEventListener('click', () => this.updateLine(key, Math.max(0, parseInt(input.value, 10) - 1)));
        if (increase) increase.addEventListener('click', () => this.updateLine(key, parseInt(input.value, 10) + 1));
        if (remove) remove.addEventListener('click', () => this.updateLine(key, 0));
        if (input) input.addEventListener('change', () => this.updateLine(key, parseInt(input.value, 10) || 0));
      });
    }

    wireQuickAddForms() {
      document.querySelectorAll('[data-quick-add]').forEach((form) => {
        form.addEventListener('submit', (e) => {
          const button = form.querySelector('[data-has-options]');
          if (button) return; // multi-variant — let it go to product page
          e.preventDefault();
          const id = form.querySelector('input[name="id"]').value;
          this.addItem(id, 1);
        });
      });
    }

    async addItem(variantId, quantity) {
      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity }] }),
        });
        await this.refresh();
        this.open();
      } catch (err) {
        console.error('Cart add failed', err);
      }
    }

    async updateLine(key, quantity) {
      try {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity }),
        });
        await this.refresh();
      } catch (err) {
        console.error('Cart update failed', err);
      }
    }

    // The Skip the Line fee is a line item that the cart doesn't show as one, so
    // it must not inflate the counts either.
    visibleItemCount(cart) {
      const config = document.querySelector('[data-skip-line]');
      const feeVariantId = config ? parseInt(config.dataset.variantId, 10) : 0;
      if (!feeVariantId) return cart.item_count;
      return cart.items.reduce(
        (count, item) => (item.variant_id === feeVariantId ? count - item.quantity : count),
        cart.item_count
      );
    }

    async refresh() {
      const response = await fetch(`${window.location.pathname}?sections=cart-drawer`);
      const data = await response.json();
      const html = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
      const fresh = html.querySelector('[data-cart-drawer]');
      if (fresh) {
        this.innerHTML = fresh.innerHTML;
        this.panel = this.querySelector('[data-cart-panel]');
        this.closers = this.querySelectorAll('[data-cart-close]');
        this.closers.forEach((c) => c.addEventListener('click', () => this.close()));
        this.wireLineControls();
      }
      // Update header cart count
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();
      const count = this.visibleItemCount(cart);
      document.querySelectorAll('.header__cart-count, [data-cart-count]').forEach((el) => {
        el.textContent = el.classList.contains('header__cart-count') ? count : `(${count})`;
      });
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
    }
  }

  if (!customElements.get('cart-drawer')) {
    customElements.define('cart-drawer', CartDrawer);
  }

  // Wire the header cart icon
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-cart-drawer-toggle]').forEach((trigger) => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        document.dispatchEvent(new CustomEvent('cart:open'));
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function () {
    var page = document.querySelector('[data-cart-page]');
    if (!page) return;

    page.querySelectorAll('[data-cart-line]').forEach(function (line) {
      var key = line.dataset.lineKey;
      var input = line.querySelector('[data-line-qty]');
      var decrease = line.querySelector('[data-line-decrease]');
      var increase = line.querySelector('[data-line-increase]');
      var remove = line.querySelector('[data-line-remove]');

      function update(qty) {
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: qty })
        }).then(function () { window.location.reload(); });
      }

      if (decrease) decrease.addEventListener('click', function () { update(Math.max(0, parseInt(input.value, 10) - 1)); });
      if (increase) increase.addEventListener('click', function () { update(parseInt(input.value, 10) + 1); });
      if (input) input.addEventListener('change', function () { update(parseInt(input.value, 10) || 0); });
      if (remove) remove.addEventListener('click', function () { update(0); });
    });

    var discount = page.querySelector('[data-discount]');
    if (!discount) return;

    var codeInput = discount.querySelector('[data-discount-input]');
    var applyButton = discount.querySelector('[data-discount-apply]');
    var errorMessage = discount.querySelector('[data-discount-error]');

    function applyCode() {
      var code = (codeInput.value || '').trim();
      if (!code) return;
      applyButton.setAttribute('aria-disabled', 'true');
      // Come back to this same path — which preserves the active locale — and
      // carry the attempt so the reload can tell whether it was accepted.
      var target = window.location.pathname + '?discount_code=' + encodeURIComponent(code);
      window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(target);
    }

    applyButton.addEventListener('click', applyCode);

    // The field lives inside the cart form, whose first submit button is
    // Checkout — Enter here must apply the code, not skip to checkout.
    codeInput.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter') return;
      event.preventDefault();
      applyCode();
    });

    // /discount always redirects, so a rejected code is only detectable by its
    // absence from the applied list.
    var attempted = new URLSearchParams(window.location.search).get('discount_code');
    if (attempted) {
      var applied = (discount.dataset.appliedCodes || '')
        .split('|')
        .map(function (title) { return title.trim().toLowerCase(); })
        .filter(Boolean);

      if (applied.indexOf(attempted.trim().toLowerCase()) === -1) {
        errorMessage.hidden = false;
        codeInput.value = attempted;
      }
      // Drop the marker so a refresh doesn't replay the result
      window.history.replaceState({}, '', window.location.pathname);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function () {
    // Auto-submit sort dropdown
    var sort = document.querySelector('[data-sort-select]');
    if (sort) {
      sort.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sort.value);
        window.location.href = url.toString();
      });
    }

    // Mobile filter drawer
    var filters = document.querySelector('[data-collection-filters]');
    var toggle = document.querySelector('[data-filter-toggle]');
    var closers = document.querySelectorAll('[data-filter-close]');
    var backdrop = document.querySelector('[data-filter-backdrop]');
    if (filters && toggle) {
      function open() {
        filters.classList.add('is-open');
        toggle.setAttribute('aria-expanded', 'true');
        if (backdrop) backdrop.removeAttribute('hidden');
        document.body.classList.add('drawer-open');
      }
      function close() {
        filters.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
        if (backdrop) backdrop.setAttribute('hidden', '');
        document.body.classList.remove('drawer-open');
      }
      toggle.addEventListener('click', open);
      closers.forEach(function (c) { c.addEventListener('click', close); });
      if (backdrop) backdrop.addEventListener('click', close);
      document.addEventListener('maison:escape', close);
    }

    // Active filter count badge
    var countEl = document.querySelector('[data-active-filter-count]');
    if (countEl) {
      var checked = document.querySelectorAll('[data-filter-form] input[type="checkbox"]:checked');
      if (checked.length > 0) {
        countEl.textContent = checked.length;
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["countdown"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var els = document.querySelectorAll('[data-countdown]');
    els.forEach(function (root) {
      var targetISO = root.getAttribute('data-target');
      if (!targetISO) return;
      var target = new Date(targetISO).getTime();
      if (isNaN(target)) return;

      var timer = root.querySelector('[data-timer]');
      var message = root.querySelector('[data-message]');
      var daysEl = root.querySelector('[data-days]');
      var hoursEl = root.querySelector('[data-hours]');
      var minutesEl = root.querySelector('[data-minutes]');
      var secondsEl = root.querySelector('[data-seconds]');
      var showSeconds = root.getAttribute('data-show-seconds') === 'true';

      function pad(n) { return n < 10 ? '0' + n : String(n); }

      function tick() {
        var diff = target - Date.now();
        if (diff <= 0) {
          if (timer) timer.hidden = true;
          if (message) message.hidden = false;
          clearInterval(interval);
          return;
        }
        if (timer) timer.hidden = false;
        if (message) message.hidden = true;

        var days = Math.floor(diff / (1000 * 60 * 60 * 24));
        var hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
        var minutes = Math.floor((diff / (1000 * 60)) % 60);
        var seconds = Math.floor((diff / 1000) % 60);

        if (daysEl) daysEl.textContent = pad(days);
        if (hoursEl) hoursEl.textContent = pad(hours);
        if (minutesEl) minutesEl.textContent = pad(minutes);
        if (secondsEl) secondsEl.textContent = pad(seconds);
      }

      tick();
      var interval = setInterval(tick, showSeconds ? 1000 : 60000);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-products"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('[data-featured-products]');
    sections.forEach(function (section) {
      var viewport = section.querySelector('[data-viewport]');
      var prev = section.querySelector('[data-prev]');
      var next = section.querySelector('[data-next]');
      if (!viewport || !prev || !next) return;

      function step() {
        var item = viewport.querySelector('li');
        return item ? item.getBoundingClientRect().width : 300;
      }

      function update() {
        var atStart = viewport.scrollLeft <= 4;
        var atEnd = viewport.scrollLeft + viewport.clientWidth >= viewport.scrollWidth - 4;
        prev.disabled = atStart;
        next.disabled = atEnd;
      }

      prev.addEventListener('click', function () {
        viewport.scrollBy({ left: -step(), behavior: 'smooth' });
      });
      next.addEventListener('click', function () {
        viewport.scrollBy({ left: step(), behavior: 'smooth' });
      });
      viewport.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update, { passive: true });
      update();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var header = document.querySelector('[data-header]');
    var toggle = document.querySelector('[data-mobile-toggle]');
    var drawer = document.querySelector('[data-mobile-drawer]');
    if (!header || !toggle || !drawer) return;

    var panel = drawer.querySelector('[data-mobile-panel]');
    var closers = drawer.querySelectorAll('[data-mobile-close]');
    var lastFocused = null;

    function focusables() {
      return panel.querySelectorAll(
        'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'
      );
    }

    function openDrawer() {
      lastFocused = document.activeElement;
      drawer.removeAttribute('hidden');
      // Force reflow so the transition runs from the closed state
      void drawer.offsetWidth;
      drawer.setAttribute('aria-hidden', 'false');
      toggle.setAttribute('aria-expanded', 'true');
      document.body.classList.add('drawer-open');
      var first = focusables()[0];
      if (first) first.focus();
      document.addEventListener('keydown', trap);
    }

    function closeDrawer() {
      drawer.setAttribute('aria-hidden', 'true');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('drawer-open');
      document.removeEventListener('keydown', trap);
      // Hide once the transition finishes so it stops receiving pointer events
      setTimeout(function () {
        if (drawer.getAttribute('aria-hidden') === 'true') {
          drawer.setAttribute('hidden', '');
        }
      }, 400);
      if (lastFocused && typeof lastFocused.focus === 'function') {
        lastFocused.focus();
      }
    }

    function trap(event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        closeDrawer();
        return;
      }
      if (event.key !== 'Tab') return;
      var list = focusables();
      if (list.length === 0) return;
      var first = list[0];
      var last = list[list.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    toggle.addEventListener('click', openDrawer);
    closers.forEach(function (button) {
      button.addEventListener('click', closeDrawer);
    });
    document.addEventListener('maison:escape', closeDrawer);

    // Sticky-header shrink-on-scroll AND transparent-to-solid swap
    var needsScrollTracking =
      header.classList.contains('header--sticky') ||
      header.classList.contains('header--transparent');
    if (needsScrollTracking) {
      var threshold = 60;
      var lastScrolled = false;
      window.addEventListener(
        'scroll',
        function () {
          var scrolled = window.scrollY > threshold;
          if (scrolled === lastScrolled) return;
          lastScrolled = scrolled;
          header.classList.toggle('is-scrolled', scrolled);
        },
        { passive: true }
      );
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var heroes = document.querySelectorAll('[data-slideshow]');
    if (!heroes.length) return;

    heroes.forEach(function (hero) {
      var slides = hero.querySelectorAll('[data-slide]');
      var dots = hero.querySelectorAll('[data-dot]');
      var prev = hero.querySelector('[data-prev]');
      var next = hero.querySelector('[data-next]');
      var current = 0;
      var timer = null;
      var autoplay = hero.dataset.autoplay === 'true';
      var interval = parseInt(hero.dataset.autoplayInterval, 10) || 5000;
      var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function show(index) {
        if (index < 0) index = slides.length - 1;
        if (index >= slides.length) index = 0;
        slides.forEach(function (s, i) { s.classList.toggle('is-active', i === index); });
        dots.forEach(function (d, i) {
          d.classList.toggle('is-active', i === index);
          d.setAttribute('aria-selected', i === index ? 'true' : 'false');
        });
        current = index;
      }

      function start() {
        if (!autoplay || prefersReduced) return;
        stop();
        timer = window.setInterval(function () { show(current + 1); }, interval);
      }
      function stop() { if (timer) { window.clearInterval(timer); timer = null; } }

      if (prev) prev.addEventListener('click', function () { show(current - 1); start(); });
      if (next) next.addEventListener('click', function () { show(current + 1); start(); });
      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () { show(i); start(); });
      });
      hero.addEventListener('mouseenter', stop);
      hero.addEventListener('mouseleave', start);
      hero.addEventListener('focusin', stop);
      hero.addEventListener('focusout', start);

      // Activate first slide and kick off autoplay
      show(0);
      start();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-addresses"]) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-toggle-form]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var key = trigger.dataset.toggleForm;
        var form = document.querySelector('[data-form="' + key + '"]');
        if (!form) return;
        if (form.hasAttribute('hidden')) form.removeAttribute('hidden');
        else form.setAttribute('hidden', '');
      });
    });
    document.querySelectorAll('[data-delete]').forEach(function (button) {
      button.addEventListener('click', function (e) {
        if (!confirm('Are you sure you want to delete this address?')) e.preventDefault();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      // Only the Shopify-powered sources carry a URL; collection and manual
      // picks are already rendered server-side.
      if (!this.dataset.url || this.dataset.loaded === 'true') return;

      // Below the fold on every product page — don't spend the request until
      // it's close to being seen.
      const observer = new IntersectionObserver(
        (entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          observer.disconnect();
          this.load();
        },
        { rootMargin: '400px' }
      );
      observer.observe(this);
    }

    load() {
      this.dataset.loaded = 'true';
      fetch(this.dataset.url)
        .then((response) => {
          if (!response.ok) throw new Error('Recommendations request failed: ' + response.status);
          return response.text();
        })
        .then((text) => {
          const markup = new DOMParser().parseFromString(text, 'text/html');
          const fresh = markup.querySelector('product-recommendations');
          // Swapping innerHTML rather than the element keeps this instance —
          // and its data-loaded flag — so the fetch can't recurse.
          if (fresh) this.innerHTML = fresh.innerHTML;
        })
        .catch((error) => console.error('Product recommendations failed', error));
    }
  }

  if (!customElements.get('product-recommendations')) {
    customElements.define('product-recommendations', ProductRecommendations);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-product-section]').forEach(function (section) {
      // Quantity stepper
      var qtyInput = section.querySelector('[data-quantity-input]');
      var qtyButtons = section.querySelectorAll('[data-quantity-action]');
      qtyButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          var value = parseInt(qtyInput.value, 10) || 1;
          if (button.dataset.quantityAction === 'increase') value += 1;
          else value = Math.max(1, value - 1);
          qtyInput.value = value;
          qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });

      // React to variant changes — update ATC button label and price
      var picker = section.querySelector('variant-picker');
      var atcLabel = section.querySelector('[data-atc-label]');
      var atcButton = section.querySelector('[data-atc-button]');
      var priceBlock = section.querySelector('[data-price-block]');
      if (!picker) return;

      function formatMoney(cents) {
        return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: window.Shopify ? window.Shopify.currency.active : 'USD' });
      }

      picker.addEventListener('variant:change', function (event) {
        var variant = event.detail.variant;
        if (!variant) return;
        if (variant.available) {
          atcButton.removeAttribute('disabled');
          atcLabel.textContent = ((window.Maison && window.Maison.t && window.Maison.t.addToCart) || 'Add to cart') + ' — ' + formatMoney(variant.price);
        } else {
          atcButton.setAttribute('disabled', 'disabled');
          atcLabel.textContent = (window.Maison && window.Maison.t && window.Maison.t.soldOut) || 'Sold out';
        }
        if (priceBlock) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            priceBlock.innerHTML =
              '<s class="product-section__price-compare">' + formatMoney(variant.compare_at_price) + '</s>' +
              '<span class="product-section__price-sale">' + formatMoney(variant.price) + '</span>';
          } else {
            priceBlock.innerHTML = '<span>' + formatMoney(variant.price) + '</span>';
          }
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.video-banner').forEach(function (banner) {
      var video = banner.querySelector('video');
      if (!video) return;

      // Reveal the video only once it has a frame to show, so the poster never
      // cross-fades to a blank box on a slow connection.
      function markPlaying() {
        banner.classList.add('video-banner--playing');
      }
      if (video.readyState >= 3) markPlaying();
      video.addEventListener('playing', markPlaying, { once: true });

      // Safari refuses autoplay in low power mode and rejects the promise;
      // leaving the poster up is the correct outcome, not an error.
      var attempt = video.play();
      if (attempt && typeof attempt.catch === 'function') {
        attempt.catch(function () {});
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
